module.exports = __webpack_public_path__ + "img/pdf.691979cf.svg";